export default __webpack_public_path__ + "static/media/27.c58cb915.jpg";